import React from 'react';
import BookingBarModule from './BookingBarModule';
import StickyBookingBarSimpleModule from './StickyBookingBarSimpleModule';
import { useSelector } from 'react-redux';
import { selectIsRobot } from '@/store/index';
import SelfbookBookingBarModule from './SelfbookBookingBarModule';

const StickyBookingBarModule = ({ data }) => {
  const isRobot = useSelector(selectIsRobot);
  if (isRobot) return;
  if (data.displayBookingBar === false) return null;
  if (data.isSimpleBookingBar && !data.useSelfBookNativeBookingBar) {
    return <StickyBookingBarSimpleModule data={data.simpleBooking} bgColor={data.backgroundColor} />;
  }
  if (!data.isSimpleBookingBar && data.fullBooking !== null && !data.useSelfBookNativeBookingBar) {
    return <BookingBarModule data={data.fullBooking} />;
  }

  if (data.useSelfBookNativeBookingBar && !data.isSimpleBookingBar && data.fullBooking !== null) {
    return <SelfbookBookingBarModule data={data.fullBooking} />;
  }
};
export default StickyBookingBarModule;
